<template>
  <b-form-group
    :label-for="name"
    v-if="params && params.show"
    :invalid-feedback="invalidFeedback"
    :state="state"
    class="fph"
  >
    <template slot="label" v-if="label && !placeholder"
      >{{ $t(params.libelle) }} <sup v-if="params.required">*</sup></template
    >
    <b-form-input
      :id="name"
      :value="model"
      :required="params.required"
      :maxlength="params.max_length"
      :formatter="formatter"
      @input="emit($event)"
      :placeholder="placeholder ? $t(params.libelle) : ''"
      :class="state ? '' : 'stateError'"
    ></b-form-input>
  </b-form-group>
</template>

<script>
import axios from "axios";
export default {
  name: "DynField",
  components: {},
  data() {
    return {
      params: {},
      state: true,
      invalidFeedback: "Merci de respecter le formatage du champs.",
      PATTERNS: {
        onlytext: {
          pattern: /[^a-zA-Z]/g,
          match: false,
          format: "Lettres uniquement",
          nb_required: false,
        },
        onlynumber: {
          pattern: /[^0-9]/g,
          match: false,
          format: "Chiffres uniquement",
          nb_required: false,
        },
        N_GED_BNPPF: {
          pattern: /(4)[0-9]{7}/g,
          match: true,
          format: "4XXXXXXX",
          nb_required: 8,
        },
        allchars: {
          pattern: /.*/g,
          match: true,
          format: "",
          nb_required: false,
        },
      },
      pattern: {},
    };
  },
  props: {
    name: String,
    label: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  computed: {
    model() {
      return this.value && this.value != "null" ? this.value : "";
    },
  },
  methods: {
    emit(val) {
      this.$emit("input", val);
    },
    formatter(value) {
      if (this.pattern === null) return value;
      if (this.pattern.match) {
        if (value.match(this.pattern.pattern)) {
          this.state = true;
          return value;
        } else {
          this.state = false;
          this.invalidFeedback =
            value.length < this.pattern.nb_required
              ? ""
              : "Merci de respecter le format : " + this.pattern.format;
          return value;
        }
      } else {
        this.state = true;
        var nval = value.replace(this.pattern.pattern, "");
        return nval;
      }
    },
    get_params() {
      if (localStorage.getItem("field_" + this.name)) {
        this.params = JSON.parse(localStorage.getItem("field_" + this.name));
        this.$emit("load", this.params);
      } else {
        axios
          .get(
            this.$apiUrl +
              "params/fields/field_" +
              this.name +
              "?auth=" +
              JSON.stringify(this.auth_header())
          )
          .then((response) => {
            this.params = response.data;
            localStorage.setItem(
              "field_" + this.name,
              JSON.stringify(response.data)
            );
            this.$emit("load", this.params);
            this.pattern =
              this.params.pattern in this.PATTERNS
                ? this.PATTERNS[this.params.pattern]
                : this.PATTERNS.allchars;
            if (this.pattern.nb_required)
              this.params.max_length = this.pattern.nb_required;
            if (!this.pattern.nb_required)
              this.pattern.nb_required = this.params.min_length;
          });
      }
    },
  },
  mounted() {
    this.get_params();
  },
};
</script>
